export default __webpack_public_path__ + "static/highlight-3-cc5b29deb0fcd22c7fa7578d69e043ef.svg";